import { AdminFeatureFlagScreen } from '@/screens/admin/admin-feature-flag-screen'

export default function () {
  return <AdminFeatureFlagScreen />
}
